import { motion, useInView } from 'motion/react';
import { useRef } from 'react';

import { cn } from '~/lib/utils';

interface ProductMainPhraseSectionProps {
  text: string;
  className?: string;
  textClassName?: string;
}

export const ProductMainPhraseSection = ({
  text,
  className,
  textClassName,
}: ProductMainPhraseSectionProps) => {
  const containerRef = useRef<HTMLParagraphElement>(null);
  const isInView = useInView(containerRef, { once: true, amount: 0.3 });
  const words = text.split(' ');

  return (
    <section className={cn('bg-black px-4 md:px-20 py-[120px] md:py-[200px]', className)}>
      <p ref={containerRef} className={cn(
        "text-center text-white max-w-[1320px] mx-auto font-['Manrope','Manrope_Fallback',sans-serif] text-[40px] md:text-[96px] font-normal leading-[1.2]",
        textClassName
      )}>
        {words.map((word, i) => (
          <span key={i} className="inline-block align-bottom">
            <motion.span
              className="inline-block"
              style={{ willChange: 'transform, opacity' }}
              initial={{ y: '40%', opacity: 0 }}
              animate={isInView ? { y: '0%', opacity: 1 } : { y: '40%', opacity: 0 }}
              transition={{
                duration: 0.8,
                ease: [0.25, 0.1, 0.25, 1],
                delay: i * 0.03,
                opacity: {
                  duration: 1.2,
                  ease: [0.4, 0, 0.2, 1],
                  delay: i * 0.03,
                },
              }}
            >
              {word}
            </motion.span>
            {i < words.length - 1 && '\u00A0'}
          </span>
        ))}
      </p>
    </section>
  );
};
